export * from './amenities-mobile';
